
import { trueFalseToYesNo } from '@/util/formatters'

/*(value) => { return value == true ? 'YES' : 'NO' }*/

let personalDetailsInputs = [
    {
        id: 'identificationNumber',
        label: 'Identification number',
        type: 'text',
        placeholder: 'Identification number',
        dataPath: 'claimantDetails.identificationNumber'
    },
  {
      id: 'isPolicyholder',
      label: 'Policyholder',
      type: 'text',
      placeholder: 'Policyholder',
      dataPath: 'claimantDetails.policyholder',
      customFormatter: trueFalseToYesNo 
  },
  {
      id: 'isUKResident',
      label: 'UK Resident',
      type: 'text',
      placeholder: 'UK Resident',
      dataPath: 'claimantDetails.ukResident',
      customFormatter: trueFalseToYesNo 
  },
  {
      id: 'isVatRegistered',
      label: 'VAT Registered',
      type: 'text',
      placeholder: 'VAT Registered',
      dataPath: 'claimantDetails.vatRegistered',
      customFormatter: trueFalseToYesNo 
  },
  {
        id: 'telephone',
        label: 'Alternate Telephone',
        type: 'text',
        placeholder: 'Alternate Telephone',
        dataPath: 'claimantDetails.telephoneNumber'
  },
  {
      id: 'name',
      label: 'Name',
      type: 'text',
      placeholder: 'Name',
      dataPath: 'claimantDetails.fullname'
  },
  {
      id: 'dateOfBirth',
      label: 'Date of Birth',
      type: 'text',
      placeholder: 'Date of Birth',
      dataPath: 'claimantDetails.dateOfBirth'
  },
  {
      id: 'email',
      label: 'Email',
      type: 'text',
      placeholder: 'Email',
      dataPath: 'claimantDetails.email',
      copy: true
  },
  {
      id: 'mobile',
      label: 'Telephone',
      type: 'text',
      placeholder: 'Telephone',
      dataPath: 'claimantDetails.mobileNumber'
  },
  {
      id: 'addressLine1',
      label: 'Address',
      type: 'text',
      placeholder: 'Line 1',
      dataPath: 'claimantDetails.line1'
  },
  {
      id: 'addressLine2',
      label: '',
      type: 'text',
      placeholder: 'Line 2',
      dataPath: 'claimantDetails.line2'
  },
  {
      id: 'town',
      label: 'Town / City',
      type: 'text',
      placeholder: 'Town / City',
      dataPath: 'claimantDetails.city'
  },
  {
      id: 'county',
      label: 'County',
      type: 'text',
      placeholder: 'County',
      dataPath: 'claimantDetails.county'
  },
  {
      id: 'postcode',
      label: 'Postcode',
      type: 'text',
      placeholder: 'Postcode',
      dataPath: 'claimantDetails.postcode',
      copy: true
  }
]

export { personalDetailsInputs }